<template>
  <div class="panel panel-default">
    <div
      class="panel-heading"
      style="
        border-left: solid 1px #ddd;
        border-right: solid 1px #ddd;
        border-top: solid 1px #ddd;
      "
    >
      <div class="row">
        <div class="col-md-6">
          <h5 class="text-left">
            <strong>Order Summary</strong>
          </h5>
        </div>
        <div class="col-md-6">
          <div class="text-right" style="margin-top: 10px; margin-bottom: 10px">
            <button
              id="estimate-tax-btn"
              class="btn btn-md btn-primary checkout-btn"
              :class="{ disabled: submitting }"
              :disabled="newAddressPending"
              @click="estimateTax()"
            >
              Estimate Tax
            </button>
            <inline-loading-indicator
              v-if="submitting"
            ></inline-loading-indicator>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-if="taxMessage"
          id="tax-message"
          class="alert alert-warning col-md-8 col-md-offset-2 text-center"
        >
          {{ taxMessage }}
        </div>
      </div>
    </div>
    <div
      class="panel-body"
      style="
        border-left: solid 1px #ddd;
        border-right: solid 1px #ddd;
        border-top: solid 1px #ddd;
        border-bottom: solid 1px #ddd;
      "
    >
      <table class="pad-bottom table">
        <thead></thead>
        <tbody>
          <tr>
            <td>Products:&nbsp;</td>
            <td class="text-right">
              {{ productTotal | money }}
              <small>{{ currencyLabel }}</small>
            </td>
          </tr>
          <tr>
            <td>Shipping:&nbsp;</td>
            <td class="text-right">
              {{ shippingTotal | money }}
              <small>{{ currencyLabel }}</small>
            </td>
          </tr>
          <tr>
            <td>Subtotal:&nbsp;</td>
            <td class="text-right">
              {{ subTotal | money }}
              <small>{{ currencyLabel }}</small>
            </td>
          </tr>
          <tr>
            <td>*Estimated tax:&nbsp;</td>
            <td class="text-right">
              {{ estimatedTaxCost | money }}
              <small>{{ currencyLabel }}</small>
            </td>
          </tr>
          <tr>
            <td><h4>Order total:&nbsp;</h4></td>
            <td class="text-right">
              <h4>
                {{ orderTotal | money }}
                <small>{{ currencyLabel }}</small>
              </h4>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="panel-footer"
      style="
        border-left: solid 1px #ddd;
        border-right: solid 1px #ddd;
        border-bottom: solid 1px #ddd;
      "
    >
      <small>
        * Tax is estimated based on the shipping / installation address. If
        applicable, tax is calculated during order processing and amounts may
        vary. If your organization is exempt, you may update your status in the
        <a :href="manageExemptionsRoute" title="Tax Exemptions">
          Tax Exemptions
        </a>
        section of your account.
      </small>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    money(val) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD", // this seems to be ok because we put the currenty label after it
      });

      return formatter.format(val);
    },
  },

  props: {
    productTotal: {
      type: Number,
      required: true,
    },
    currencyLabel: {
      type: String,
      required: true,
    },
    manageExemptionsRoute: {
      type: String,
      required: true,
    },
    estimateTaxRoute: {
      type: String,
      required: true,
    },
    shippingAddressId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      shippingTotal: 0,
      estimatedTaxCost: 0,
      submitting: false,
      taxMessage: null,
    };
  },

  computed: {
    newAddressPending() {
      return !this.shippingAddressId;
    },
    subTotal() {
      return this.productTotal + this.shippingTotal;
    },
    orderTotal() {
      return this.productTotal + this.shippingTotal + this.estimatedTaxCost;
    },
  },

  methods: {
    estimateTax() {
      const payload = {
        id: this.shippingAddressId,
      };

      this.submitting = true;
      this.taxMessage = null;

      this.$http
        .post(this.estimateTaxRoute, payload)
        .then((response) => {
          this.taxMessage = "Success! Details below.";
          this.estimatedTaxCost = Number(response.data);
        })
        .catch((e) => {
          this.taxMessage = e.response.data.message;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
